import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import axios from 'axios';
import { toError, assertOk } from '@/services/normalize';

import {
  BASE_URL,
  BANKACCOUNT_LIST,
  BANKACCOUNT_CREATE,
  BANKACCOUNT_UPDATE,
  BANKACCOUNT_DELETE,
  BANK_NAME_LIST,
  M_POST
} from '@/utils/api';

@Module({ name: 'bankaccount' })
export default class Bankaccount extends VuexModule {
  bankaccountList: unknown[] = [];

  bankNameList: unknown[] = [];

  @Mutation
  mutateBankNameList(data: unknown[]) {
    this.bankNameList = data;
  }

  @Mutation
  mutateBankaccount(bankaccount: unknown[]) {
    this.bankaccountList = bankaccount;
  }

  @Action({ commit: 'mutateBankNameList', rawError: true })
  async FetchBankName(params: Record<string, unknown> = {}) {
    try {
      const { data } = await axios({
        url: BASE_URL + BANK_NAME_LIST,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Fetch bank name failed');
      return data?.data;
    } catch (err) {
      throw toError(err, 'Fetch bank name failed');
    }
  }

  @Action({ commit: 'mutateBankaccount', rawError: true })
  async FetchBankAccount(params: Record<string, unknown> = {}) {
    try {
      const { data } = await axios({
        url: BASE_URL + BANKACCOUNT_LIST,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Fetch bank account failed');
      return data?.data;
    } catch (err) {
      throw toError(err, 'Fetch bank account failed');
    }
  }

  @Action({ rawError: true })
  async CreateBankAccount(params: Record<string, unknown>) {
    try {
      const { data } = await axios({
        url: BASE_URL + BANKACCOUNT_CREATE,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Create bank account failed');
      return data?.status;
    } catch (err) {
      throw toError(err, 'Create bank account failed');
    }
  }

  @Action({ rawError: true })
  async UpdateBankAccount(params: Record<string, unknown>) {
    try {
      const { data } = await axios({
        url: BASE_URL + BANKACCOUNT_UPDATE,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Update bank account failed');
      return data?.status;
    } catch (err) {
      throw toError(err, 'Update bank account failed');
    }
  }

  @Action({ rawError: true })
  async DeleteBankAccount(params: Record<string, unknown>) {
    try {
      const { data } = await axios({
        url: BASE_URL + BANKACCOUNT_DELETE,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Delete bank account failed');
      return data?.status;
    } catch (err) {
      throw toError(err, 'Delete bank account failed');
    }
  }

  @Action({ commit: 'mutateBankaccount', rawError: true })
  async TranAcc(transaction: unknown) {
    return transaction as any;
  }
}
